import React, { Component } from 'react';
import { func, bool } from 'prop-types';
import { connect } from 'react-redux';
import BackButton from '../BackButton';
import { surveyFieldIds } from '../../constants';
import EmailMessageInput from '../EmailMessageInput';
import WithValidation from '../WithValidation';
import { surveyOptionsType } from '../../constants/types';
import { surveyReminderValidator } from '../../validators/surveys';
import {
  clearSurveyAction,
  sendNotificationAction,
  updateSurveyOptionsAction
} from '../../actions';
import sharedStyles from '../../styles/shared';
import { getMessages, withLang, langType } from '../../i18n';
import withRouter from '../WithRouter';
import { setDocumentTitle } from '../../util';

const submit = (surveyOptions, dispatchSendNotification, onAfterSave) => (event) => {
  event.preventDefault();
  dispatchSendNotification(
    surveyOptions.reminderEmailTitle,
    surveyOptions.reminderEmailContent,
    onAfterSave
  );
};

class SurveyReminder extends Component {
  constructor(props) {
    super(props);
    this.state = { submitted: false };
    this.onAfterSave = this.onAfterSave.bind(this);
  }

  componentWillUnmount() {
    this.props.dispatchClear();
  }

  onAfterSave() {
    this.setState({ submitted: true });
    this.props.dispatchUpdate({
      [surveyFieldIds.REMINDER_TITLE]: undefined,
      [surveyFieldIds.REMINDER_CONTENT]: undefined
    });
  }

  render() {
    const {
      isValid, surveyOptions, dispatchSendNotification, hasInvalidField, translate: t
    } = this.props;

    const defaultSurveyReminderContentFormatted = getMessages(`defaultSurveyReminderContent.${surveyOptions.surveyType}`);
    const defaultSurveyReminderTitle = getMessages(`defaultSurveyReminderTitle.${surveyOptions.surveyType}`);
    setDocumentTitle(t('surveyReminder.title'));

    return (
      <div className="page-container">
        <BackButton />
        {(!this.state.submitted
          && (
          <div>
            <h2 className="panel__title">{t('surveyReminder.title')}</h2>
            <EmailMessageInput
              messageTitleName={surveyFieldIds.REMINDER_TITLE}
              messageContentName={surveyFieldIds.REMINDER_CONTENT}
              hasInvalidField={hasInvalidField}
              defaultTitle={defaultSurveyReminderTitle}
              defaultContent={defaultSurveyReminderContentFormatted}
            />
            <button
              type="button"
              disabled={!isValid}
              className={`button ${sharedStyles.submitButton}`}
              onClick={submit(surveyOptions, dispatchSendNotification, this.onAfterSave)}
              data-cy="save-and-send-survey-reminder-button"
            >
              {t('common.submit')}
            </button>
          </div>
          ))
          || <h2 className="panel__title">{t('surveyReminder.messageSent')}</h2>}
      </div>
    );
  }
}

SurveyReminder.propTypes = {
  isValid: bool.isRequired,
  hasInvalidField: func.isRequired,
  dispatchSendNotification: func.isRequired,
  dispatchUpdate: func.isRequired,
  dispatchClear: func.isRequired,
  surveyOptions: surveyOptionsType.isRequired,
  translate: langType.translate.isRequired
};

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions
});

const mapDispatchToProps = (dispatch, { params: { surveyId } }) => ({
  dispatchSendNotification: (title, message, callback) =>
    dispatch(sendNotificationAction(surveyId, title, message, true)).then(
      () => callback && callback()
    ),
  dispatchClear: () =>
    dispatch(clearSurveyAction()),
  dispatchUpdate: (surveyOptions) =>
    dispatch(updateSurveyOptionsAction(surveyOptions))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  withLang(WithValidation(SurveyReminder, surveyReminderValidator))
));
